import React from "react";

import PageCardRowHeader from "../../../General/PageCardRowHeader";

function SectionHeader({ title }) {
  return (
    <PageCardRowHeader
      title={title}
      titleStyle={{ paddingLeft: 0, paddingTop: 0 }}
      lineStyle={{ width: "100%" }}
    />
  );
}

export default SectionHeader;
